"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "spiazzo": {
    "243ca603": [{
      "hkey": "064c7c7a",
      "slug": "spiazzo",
      "name": "Spiazzo",
      "primary": true,
      "skipSearch": false
    }],
    "borzago": [{
      "hkey": "064c7c7a",
      "slug": "spiazzo",
      "name": "Spiazzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b2a3615d": [{
      "hkey": "064c7c7a",
      "slug": "spiazzo",
      "name": "Spiazzo",
      "primary": true,
      "skipSearch": false
    }],
    "fisto-ches": [{
      "hkey": "064c7c7a",
      "slug": "spiazzo",
      "name": "Spiazzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ba6c770a": [{
      "hkey": "064c7c7a",
      "slug": "spiazzo",
      "name": "Spiazzo",
      "primary": true,
      "skipSearch": false
    }],
    "mortaso": [{
      "hkey": "064c7c7a",
      "slug": "spiazzo",
      "name": "Spiazzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;